import React, {
  createContext,
  useState,
  ReactNode,
  useContext,
  useEffect,
} from 'react';
//import { useAppDispatch } from "../store/adminStore";

// Define the type for your context's value
export type AuthContextType = {
  auth: { loading: boolean; data: any };
  setAuthData: (data: any) => void;
};

// Create the context with the appropriate initial type
export const AuthContext = createContext<AuthContextType | null>(null);

// Define the provider component
export const AuthContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  //const dispatch = useAppDispatch();

  type AuthData = {
    accessToken: string;
    user: any;
  };

  const [auth, setAuth] = useState<{ loading: boolean; data: AuthData | null }>(
    { loading: true, data: null }
  );

  const setAuthData = (data: AuthData) => {
    setAuth({ loading: false, data });
  };

  useEffect(() => {
    const accessToken = window.localStorage.getItem('accessToken');
    const user = JSON.parse(window.localStorage.getItem('user') || '{}');
    setAuth({
      loading: false,
      data: {
        accessToken: accessToken || '',
        user: user,
      },
    });
  }, []);
  //2. if object with key 'authData' exists in localStorage, we are putting its value in auth.data and we set loading to false.
  //This function will be executed every time component is mounted (every time the user refresh the page);

  const contextValue: AuthContextType = { auth, setAuthData };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};
export const useAuth = () => {
  return useContext(AuthContext);
};
